<template>
  <div class="learning-guide-page">
    <Header :bgTransparent="headerTransparent" />
    <div class="content-top">
      <div class="content">
        <div class="content-title">{{ learnData.productName }}</div>
        <div class="content-time">
          <span>
            <template v-if="!learnData.deadlineTime">永久有效</template>
            <template v-else>
              <span class="deadline-time-text">有效期至</span>
              {{ learnData.deadlineTime | timeHandleFilter }}
            </template>
          </span>
          <span>共{{ showClassHour() }}课时</span>
        </div>
        <div class="content-rate">
          <span class="left">学习进度</span>
          <commonProgress :rate="learnData.learnProgress ? learnData.learnProgress * 100 : 0" />
          <span
            class="right"
          >{{ learnData.learnProgress ? (learnData.learnProgress * 100).toFixed(0) : 0 }}%</span>
        </div>
      </div>
      <div class="nav-bar">
        <template v-if="!treeLoading">
          <div
            v-for="item in navList"
            :key="item.val"
            @click="navClick(item)"
            :class="{ 'nav-item': true, 'nav-item-not-show': !item.show }"
          >
            <template v-if="item.show">
              <img :src="item.img" :alt="item.name" />
              <span>{{ item.name }}</span>
            </template>
          </div>
        </template>
      </div>
    </div>
    <!--  导学推荐  -->
    <div @click="jumpCourseDetail" v-if="learningGuidanceVisible" class="learning-guidance">
      <div class="learning-guidance-box">
        <img :src="this.learningGuidanceInfo.images" />
      </div>
    </div>
    <div
      :class="{ 'course-tree-title': true, 'learning-guidance-visible': learningGuidanceVisible }"
      class="course-tree-title"
    >课程目录</div>
    <div class="course-tree">
      <!-- 目录树 -->
      <CourseTree
        v-if="!treeLoading"
        :treeNodeInit="catalogData.courseNodes"
        :learningProgressList="learningProgressList"
        :learnData="learnData"
        treeType="learnGuideTree"
        :examStatusMap="examStatusMap"
      />
      <EmptyData :emptyName="'tree'" v-if="!catalogData.courseNodes" />
    </div>
    <!--    社群-->
    <footCommunity :skuInfo="learnData" ref="community" />
    <!--    loading-->
    <commonLoading v-if="treeLoading" />
    <!--    下载app弹窗-->
    <DialogComponent ref="dialogComponent" dialogType="downloadApp" />
    <Foot />
    <!-- 直播弹出 -->
    <MultipleLiveCourse
      :videoList="videoList"
      :openCourseId="Number(catalogId)"
      :gioEnter="gioEnter"
      v-if="showLive"
      @closeLive="closeLive"
    />

    <van-popup
      v-model="showPop"
      z-index="10000"
      class="agreementPop"
      :close-on-click-overlay="agreementType === 2 ? false : true"
    >
      <div v-if="agreementType === 2">
        <h2>重要提醒</h2>
        <h3>为了您的合法权益以及学习得到更好的保障，您需要在课前签订入学协议</h3>
        <div @click="toAgressment">去签署22</div>
        <span @click="goBack">暂不签署</span>
      </div>
      <div v-if="agreementType === 1">
        <h2>重要提醒</h2>
        <h3>为了您的合法权益以及学习得到更好的保障，您需要在课前签订入学协议</h3>
        <div @click="toAgressment">去签署</div>
        <span @click="noRemind">不再提示</span>
      </div>
    </van-popup>
    <AgreeTips ref="tips" :giveAgreementPop="giveAgreementPop" />
  </div>
</template>

<script>
import moment from 'moment';
import {
  reqCourseDetail,
  reqGetCatalog,
  reqBroadcasting,
  getTaskApi,
  lerningGuidanceInfo,
  reqNewLearnProgress,
  reqExamStatus,
} from '@/api/learningGuidePage/index';
// import { getTaskApi } from '@/api/entranceTask/index';
import { reqReceiveCoupon } from '@/api/coupon/index';
import Header from '@/components/learningGuidePage/header.vue';
import commonProgress from '@/components/commonComponents/commonProgress.vue';
import CourseTree from '@/components/course/CourseTree.vue';
import footCommunity from '@/pages/courseDetail/courseComponents/footCommunity.vue';
import commonLoading from '@/components/commonComponents/CommonLoading.vue';
import DialogComponent from '@/components/dialogComponent/dialogComponent.vue';
import Foot from '@/components/foot/privacy.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import MultipleLiveCourse from '@/components/multipleLiveCourse/index.vue';
import AgreeTips from '@/components/agreeTips/index.vue';
import { setBaseUrl, gioPlatform } from '@/utils/tools';
import { SKIPTYPE } from '@/utils/types';
import { reqSchemeUrl } from '@/api/openMini';
import { miniSchemeUrl } from '@/utils/common';

export default {
  components: {
    Header,
    commonProgress,
    CourseTree,
    footCommunity,
    commonLoading,
    DialogComponent,
    Foot,
    EmptyData,
    MultipleLiveCourse,
    AgreeTips,
  },
  filters: {
    timeHandleFilter(time) {
      return moment(time).format('YYYY.MM.DD'); // 重置时间格式
    },
  },
  data() {
    return {
      learnData: {},
      catalogData: {},
      treeLoading: true,
      navList: [],
      catalogId: this.$route.query.catalogId,
      headerTransparent: true,
      scrollListenFun: null,
      videoList: [],
      showLive: false,
      showPop: false,
      alertFlag: false, // 是否需要弹窗
      // completeSign: false, // 协议是否完成签署
      agreementType: 0, // 签署方式 1随时签署 2学习前签署
      giveAgreementPop: {},
      examId: '', // 入学测试ID
      learningGuidanceVisible: false,
      learningGuidanceInfo: {},
      gioEnter: '导学页',
      learningProgressList: [],
      examStatusMap: {},
      // examDone: false, // 入学考试是否完成
      // examinationDone: false, // 入学档案是否完成
    };
  },
  mounted() {
    if (!this.catalogId) {
      this.$toast('无法获取信息');
    }
    this.treeLoading = true;
    this.initData();
    this.entranceTask();
    this.$nextTick(() => {
      this.scrollInit();
    });
    window.scrollTo(0, 0);
  },
  methods: {
    showClassHour() {
      const { classHHour, completeHour } = this.learnData;
      return classHHour > completeHour ? classHHour : completeHour?.toFixed(0);
    },
    // 获取学习进度
    async getLearningProgress(id) {
      const res = await reqNewLearnProgress(id);
      if (res.code === 0) {
        this.learningProgressList = res.data;
        console.log(this.learningProgressList, 9999);
      }
    },
    goback() {
      sessionStorage.setItem('back', true);
    },
    // 跳转方法
    jumpCourseDetail() {
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      console.log('this.learnData;', this.learnData);
      const {
        skipType,
        skipUrl,
        recommendProductId,
        productCategoryId,
        productAttributeJson,
        openType,
        recommendProductName,
        learnPageRecommendDetailRespVOList,
        productId,
      } = this.learningGuidanceInfo;
      this.goback();
      // eslint-disable-next-line no-undef
      gio('track', 'adClick_event', {
        adPosition_var: '导学页推荐', // 广告位置
        pageName_var: '导学页', // 页面名称
        courseName_var: recommendProductName,
        adSequence_var: null, // 广告序号
        adId_var: recommendProductId, // 广告ID
        adName_var: recommendProductName, // 广告名称
        linesBusiness_var: null, // 业务线
        jumpType_var: SKIPTYPE[skipType], // 跳转类型
        platform_var: gioPlatform(),
      });
      if (skipType === 6) {
        this.$toast('请前往APP导学页访问');
        return;
      }
      switch (skipType) {
        case 1:
          if (this.$root.$data.isApp) {
            if (openType === 2) {
              this.$sendToApp('openBrowser', { url: skipUrl }, false);
            } else if (openType === 3) {
              this.$sendToApp('openTaobao', { url: skipUrl }, false);
            } else if (openType === 4) {
              this.$sendToApp('toTaoBaoBrowser', { url: skipUrl }, false);
            } else {
              this.$sendToApp('openNewWebView', { url: skipUrl }, false);
            }
            return;
          }
          // H5
          window.open(skipUrl);
          break;
        case 2:
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'goCourseDetail',
              Number(learnPageRecommendDetailRespVOList?.[0]?.businessId),
              false,
            );
            return;
          }
          this.$router.push({
            path: '/courseDetail',
            query: {
              courseId: learnPageRecommendDetailRespVOList?.[0]?.businessId,
            },
          });
          break;
        case 3:
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              {
                url: `${setBaseUrl(
                  '',
                )}/ark/guidanceList?type=1&productId=${recommendProductId}&skuId=${
                  this.learnData?.skuId
                }`,
              },
              false,
            );
            return;
          }
          this.$router.push({
            path: '/guidanceList',
            query: {
              type: 1,
              productId: recommendProductId,
              skuId: this.learnData?.skuId,
            },
          });
          break;
        case 4:
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              {
                url: `${setBaseUrl(
                  '',
                )}/ark/productList?type=2&productCategoryId=${productCategoryId}&productAttributeJson=${productAttributeJson ||
                  ''}`,
              },
              false,
            );
            return;
          }
          this.$router.push({
            path: '/productList',
            query: {
              type: 2,
              productCategoryId,
              productAttributeJson,
            },
          });

          break;
        case 5:
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'goToCombinationCourse',
              Number(learnPageRecommendDetailRespVOList?.[0]?.businessId),
              false,
            );
            return;
          }
          this.$router.push({
            path: '/combinationCourse',
            query: {
              combinationId: learnPageRecommendDetailRespVOList?.[0]?.businessId,
            },
          });
          break;
        case 7:
          this.couonList(productId);
          break;
        default:
      }
    },
    couonList(coupons) {
      const couponList = coupons.split(',');
      if (couponList.length > 0) {
        couponList.map(key => {
          this.getCoupons(key);
        });
      }
    },
    async getCoupons(key) {
      const res = await reqReceiveCoupon({
        couponId: String(key),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark,
      });
      if (res.code === 0) {
        this.$toast('领取成功');
      } else {
        this.$toast(res.msg);
      }
    },
    async getLive() {
      const { code, data } = await reqBroadcasting(this.catalogId);
      if (code === 0 && data.length) {
        this.showLive = true;
        data.forEach(element => {
          const { liveBaseInfoRespVO } = element;
          Object.assign(element, {
            name: element.nodeName,
            startTime: liveBaseInfoRespVO.startTime,
            endTime: liveBaseInfoRespVO.endTime,
            curriculumNodeId: element.nodeId,
            roomId: liveBaseInfoRespVO.roomId,
            courseId: element.productId,
            id: liveBaseInfoRespVO.id,
            templateType: liveBaseInfoRespVO.templateType,
          });
        });
        this.videoList = data;
      }
    },
    closeLive() {
      this.showLive = false;
    },
    scrollInit() {
      this.scrollListenFun = () => {
        const scrollTop =
          document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        const navTop = document.getElementsByClassName('content-title')[0].offsetTop;
        this.headerTransparent =
          scrollTop + document.getElementsByClassName('learn-guide-header')[0].offsetHeight <
          navTop;
      };
      document.addEventListener('scroll', this.scrollListenFun, false);
    },
    navClick(val) {
      if (val.val === 'addGroup') {
        this.$refs.community.learnGuideOpen();
      } else if (val.val === 'fuWu') {
        this.$refs.community.openPopup('default');
      } else if (val.val === 'evaluation') {
        this.$router.push({
          name: 'evaluation',
          query: {
            courseId: this.learnData.productId,
            entryType: 1,
          },
        });
      } else if (val.val === 'agreement') {
        this.$router.push({
          path: 'agreementDetail',
          query: {
            userProductId: this.catalogId,
          },
        });
      } else if (val.val === 'examDone') {
        window.location.href = `${window.location.origin}/mockExam/answerReport?examId=${this.examId}`;
      } else if (val.val === 'examinationDone') {
        this.$router.push({
          path: '/ownarchives',
        });
      } else if (val.val === 'studyReport') {
        this.$router.push({
          path: '/studyReport',
          query: {
            userProductId: this.catalogId,
            productName: this.learnData.productName,
          },
        });
      } else if (val.val === 'stageExam') {
        this.$toast('请前往APP端【导学页】完成');
      } else if (val.val === 'studyTool') {
        this.getSchemeUrl(val.appId, val.path);
      } else {
        this.$refs.dialogComponent.show = true;
      }
    },
    // h5 打开小程序的方法
    async getSchemeUrl(appid, path) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const schemeLink = await miniSchemeUrl(appid, path);
      window.location.href = schemeLink;
      this.$toast.clear();
    },
    // gio 埋点
    gioEvent(productName, productId) {
      // 曝光gio
      // eslint-disable-next-line no-undef
      gio('track', 'adShown_event', {
        adPosition_var: '导学页推荐', // 广告位置
        pageName_var: '导学页', // 页面名称
        adSequence_var: '', // 广告序号
        adId_var: productId, // 广告ID
        adName_var: productName, // 广告名称
        linesBusiness_var: '', // 业务线
        jumpType_var: '', // 跳转类型
        platform_var: 'PC',
      });
    },
    // 请求导学推荐接口
    async getLerningGuidanceInfo(productId, skuId) {
      const { data } = await lerningGuidanceInfo(productId, skuId);
      this.learningGuidanceInfo = data;
      // 如果isdisable字段是0（启用） 并且status是2的时候（展示中）才展示，否则不展示
      if (data && data?.isDisable === 0 && data?.status === 2) {
        const { productName } = this.learnData;
        this.learningGuidanceVisible = true;
        this.gioEvent(productName, productId);
      } else {
        this.learningGuidanceVisible = false;
      }
    },

    getCateExam(catalogId, productCurriculumId) {
      reqExamStatus(catalogId, productCurriculumId).then(res => {
        console.log('go1', res);
        const map = {};

        res?.data?.forEach(item => {
          map[item.id] = item.learnStatus;
        });
        this.examStatusMap = map;
      });
    },
    async initData() {
      try {
        const res = await reqCourseDetail({ id: this.catalogId });
        if (res.code === 0) {
          this.learnData = res.data;
          // console.log(res.data, 'res.datares.datares.data');
          await this.getCateExam(this.catalogId, res.data.productCurriculumId);

          this.getCatalog(this.learnData.productCurriculumId);
          this.getLearningProgress(this.catalogId);
          this.getLerningGuidanceInfo(res.data.productId, res.data?.skuId);
          const {
            isContainLecture,
            isContainAnswerQuestions,
            isContainCommunity,
            isContainAgreement,
            isContainExam,
            isContainExamination,
            isContainStageTest,
            productSkuBaseInfoRespVO,
          } = this.learnData;
          const { productStudyToolInfoRespVOList } = productSkuBaseInfoRespVO;

          const navList = [
            {
              name: '讲义',
              img: require('../../assets/img/learningGuidePage/notes.png'),
              val: 'notes',
              show: isContainLecture,
            },
            {
              name: '答疑',
              img: require('../../assets/img/learningGuidePage/question.png'),
              val: 'question',
              show: isContainAnswerQuestions,
            },
            {
              name: '入学信息',
              img: require('../../assets/img/learningGuidePage/xinxi.png'),
              val: 'examinationDone',
              show: isContainExamination,
            },
            {
              name: '入学测试',
              img: require('../../assets/img/learningGuidePage/ceshi.png'),
              val: 'examDone',
              show: isContainExam,
            },
            {
              name: '阶段测试',
              img: require('../../assets/img/learningGuidePage/stage-exam.png'),
              val: 'stageExam',
              show: isContainStageTest,
            },
            {
              name: '批改',
              img: require('../../assets/img/learningGuidePage/work.png'),
              val: 'work',
              show: this.learnData.isContainHomeWork,
            },
            {
              name: '一键加群',
              img: require('../../assets/img/learningGuidePage/add_group.png'),
              val: 'addGroup',
              show: isContainCommunity,
            },
            {
              name: '学习报告',
              img: require('../../assets/img/learningGuidePage/study-report.png'),
              val: 'studyReport',
              show: this.learnData.isContainStudyReport,
            },
            /* {
              name: '服务号',
              img: require('../../assets/img/learningGuidePage/fuwu.png'),
              val: 'fuWu',
              show: true,
            }, */
            {
              name: '协议',
              img: require('../../assets/img/learningGuidePage/xieyi.png'),
              val: 'agreement',
              show: isContainAgreement,
            },
            {
              name: '评价',
              img: require('../../assets/img/learningGuidePage/pingjia.png'),
              val: 'evaluation',
              show: true,
            },
          ];
          const tools = productStudyToolInfoRespVOList.map(item => {
            return {
              ...item,
              show: true,
              val: 'studyTool',
            };
          });
          navList.splice(8, 0, ...tools);
          this.navList = navList;
          this.getLive();
        } else {
          this.treeLoading = false;
          this.$toast(res.msg || '网络错误');
        }
      } catch {
        this.treeLoading = false;
        this.$toast('网络错误');
      }
    },
    async entranceTask() {
      const { code, data } = await getTaskApi(this.catalogId);
      if (code !== 0) return;
      const {
        agreementId,
        agreementDone,
        examId,
        examDone,
        examinationFlag,
        examinationDone,
      } = data;
      this.examId = examId;
      if (
        (agreementId && !agreementDone) ||
        (examId && !examDone) ||
        (examinationFlag && !examinationDone)
      ) {
        this.$router.push({
          path: '/entranceTask',
          query: {
            id: this.catalogId,
          },
        });
      }
    },
    async getCatalog(id) {
      try {
        const res = await reqGetCatalog(id);
        if (res.code === 0) {
          this.catalogData = res.data;
          this.treeLoading = false;
        } else {
          this.treeLoading = false;
          this.$toast(res.msg || '网络错误');
        }
      } catch {
        this.treeLoading = false;
      }
    },
    // async getAgressmentMation() {
    //   const res = await resAgreementInfo(this.catalogId);
    //   console.log(res, '查看协议');
    //   if (res.code === 0) {
    //     // this.completeSign = res.data.signFlag;
    //     this.giveAgreementPop = res.data;
    //     this.agreementType = res.data.agreementRespVO?.agreementType;
    //     this.alertFlag = res.data.alertFlag;
    //     if (res?.data?.autoFlag) {
    //       this.$refs.tips.showPop = true;
    //     }
    //     if (this.learnData.isContainAgreement === 1) {
    //       if (
    //         localStorage.getItem(this.catalogId) === this.catalogId.toString()
    //         || !this.alertFlag
    //       ) {
    //         this.showPop = false;
    //       } else {
    //         this.showPop = true;
    //       }
    //     }
    //   } else {
    //     this.$toast('请求错误！');
    //   }
    // },
    // 去签署
    toAgressment() {
      this.showPop = false;
      this.$router.push({
        path: 'agreementDetail',
        query: {
          userProductId: this.catalogId,
        },
      });
    },
    // 不再提示
    noRemind() {
      this.showPop = false;
      localStorage.setItem(this.catalogId, this.catalogId);
    },
    // 不签署
    goBack() {
      this.showPop = false;
      this.$router.go(-1);
    },
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrollListenFun, false);
  },
};
</script>

<style scoped lang="scss">
::v-deep .common-foot {
  position: fixed;
}

.learning-guide-page {
  width: 100%;
  padding-bottom: 100px;
  background: #fff;

  .content-top {
    position: relative;
    width: 100%;
    background: url('../../assets/img/learningGuidePage/bg_banner.png') no-repeat;
    background-size: 100%;

    .content {
      width: calc(100% - 72px);
      height: 100%;
      margin: 0 36px;
      padding: 100px 0 129px;

      .content-title {
        margin-top: 25px;
        color: #fff;
        font-weight: 500;
        font-size: 43px;
        line-height: 60px;
        text-shadow: 0 4px 7px rgba(0, 0, 0, 0.08);
      }

      .content-time,
      .content-rate {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 22px;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
      }

      .content-time {
        span:first-child {
          margin-right: 16px;
        }

        .deadline-time-text {
          margin-right: 14px;
        }
      }

      .content-rate {
        .left {
          margin-right: 16px;
        }

        .right {
          margin-left: 16px;
        }
      }
    }

    .nav-bar {
      position: absolute;
      bottom: -100px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: calc(100% - 72px);
      height: 200px;
      margin: 0 36px;
      overflow: auto;
      white-space: nowrap;
      background: #fff;
      border-radius: 14px;
      box-shadow: 0 5px 27px 0 rgba(154, 76, 25, 0.14);

      &::-webkit-scrollbar {
        display: none;
      }

      .nav-item {
        display: flex;
        //width: 25%;
        flex-basis: 25%;
        flex-direction: column;
        flex-shrink: 0;
        align-items: center;

        img {
          width: 87px;
          height: 87px;
        }

        span {
          color: #333;
          font-weight: 400;
          font-size: 22px;
          line-height: 36px;
        }
      }

      .nav-item-not-show {
        display: none;
        width: 0;
      }
    }
  }

  .learning-guidance {
    width: 100%;
    height: 273px;
    overflow: hidden;
    text-align: center;
    background: #fff;

    .learning-guidance-box {
      width: calc(100% - 72px);
      height: 130px;
      margin: 0 auto;
      margin-top: 142px;
      overflow: hidden;
      border-radius: 14px;
    }

    img {
      width: 100%;
    }
  }

  .course-tree-title {
    margin-top: 140px;
    margin-left: 36px;
    color: #333;
    font-weight: 500;
    font-size: 33px;
    line-height: 45px;
  }

  .course-tree-title.learning-guidance-visible {
    margin-top: 58px;
  }

  .agreementPop {
    z-index: 10001 !important;
    box-sizing: border-box;
    width: 634px;
    height: 415px;
    padding: 29px 51px;
    background: #fff;
    border-radius: 14px;

    > div {
      text-align: center;

      h2 {
        padding-bottom: 51px;
        color: #000;
        font-weight: 500;
        font-size: 33px;
        line-height: 45px;
      }

      h3 {
        color: #000;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
      }

      > div {
        width: 326px;
        height: 80px;
        margin: 43px auto 14px auto;
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 80px;
        background: #ff6c02;
        border-radius: 40px;
      }

      span {
        display: block;
        color: #999;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }
}

::v-deep .emptyIndent .hide {
  display: none;
}

::v-deep .van-overlay {
  // z-index: 10000 !important;
  // background-color: rgba(255,255,255,0);
}
</style>
